import { useState } from 'react';
import Fixed from './listview/fixedIncidents';
import Planned from './listview/plannedMaintenance';
import External from './listview/externalIncidents';
import { TimerProvider } from './contextProviders/TimerContext';
import { CollapseContext } from './contextProviders/CollapseContext';

export default function() {
    const [expanded, setExpanded] = useState(0);

	function toggle(value: number) {
		setExpanded(expanded == value ? null : value)
	};

	return <>	
		<section className="icon_description clearfix">
			<article title="Legende"> 
				<div className="flL">
					<span className="icon state_ok"></span> verfügbar
				</div>
				<div className="flL">
					<span className="icon state_maintenance"></span> Wartung
				</div>
				<div className="flL">
					<span className="icon state_problem"></span> eingeschränkt verfügbar
				</div>
				<div className="flL">
					<span className="icon state_notok"></span> nicht verfügbar
				</div>
			</article>
		</section>
		<section className="incidents">
		    <TimerProvider>
      			<CollapseContext value=>
					<Fixed/>
					<Planned/>
					<External/>
				</CollapseContext>
			</TimerProvider>
		</section>
	</>
}